export const enum SuggestionType {
  Cheapest = 'cheapest',
  MostPopular = 'mostPopular',
}

export const enum InfoIconPosition {
  None = 'none',
  Inside = 'inside',
  Outside = 'outside',
}

export const enum SuggestionTypeSelectorSize {
  Small = 'size-s',
  Normal = 'size-m',
  Large = 'size-l',
}
